<template>
  <div>
    <Panel :module="panel.module" :title="panel.title" :showVerticalFilter="panel.showVerticalFilter"
      :showSearch="panel.showSearch" :showButtons="panel.showButtons">
      <div slot="content-filter-vertical">
        <slot name="content-filter-vertical"></slot>
      </div>
      <div slot="content-buttons">
        <slot name="content-buttons"></slot>
      </div>
      <div slot="content-main">
        <slot name="content-between-search-table"></slot>
        <FilterQuery v-if="filters.length > 0" :filters="filters" v-model="stringFilter" />
        <Molded>
          <ListViewWithDataHandler :templateList="templateList" :actions="actions"
            :propsParam="{ ...propsParam, stringFilter: JSON.stringify(stringFilter) }" :isFilterStorage="true"
            :buttonRemove="buttonRemove">
            <div slot="content-buttons-table-header">
              <slot name="content-buttons-table-header"></slot>
            </div>
            <div slot="content-filter-horizontal">
              <slot name="content-filter-horizontal"></slot>
            </div>
            <div slot="content-buttons-table">
              <slot name="content-buttons-table"></slot>
            </div>
          </ListViewWithDataHandler>
        </Molded>
      </div>
    </Panel>
  </div>
</template>

<script>
import Panel from "@nixweb/nixloc-ui/src/component/layout/Panel.vue";
import Molded from "@nixweb/nixloc-ui/src/component/layout/Molded";
import ListViewWithDataHandler from "./ListViewWithDataHandler.vue";
import FilterQuery from '@nixweb/nixloc-ui/src/component/shared/filter-builder/FilterQuery.vue'

export default {
  name: "TemplateView",
  components: { Panel, Molded, ListViewWithDataHandler, FilterQuery },
  props: {
    panel: Object,
    templateList: Object,
    propsParam: Object,
    actions: {
      type: Array,
      default: [],
    },
    filters: {
      type: Array,
      default: [],
    },
    buttonRemove: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      stringFilter: [],
    }
  },
};
</script>
